<template>
  <div>
    <el-dialog
      title="Đặt cọc"
      :visible.sync="dialogDepositVisible"
      :close-on-click-modal="false"
      width="900px"
      @closed="onCloseDepositDialog"
    >
      <div>
        <BookingFormDepositDialog
          ref="BookingFormDepositDialog"
          :booking-group-id="selectedGroupData?.id"
          :booking-id="null"
        ></BookingFormDepositDialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="onCreateDeposit">
            Đặt cọc
          </button>
          <button
            class="btn primary small outline"
            @click="onCloseDepositDialog"
          >
            Đóng
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import moment from 'moment'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
// import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
// import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { createBookingDeposit } from '@/api/booking_service/deposit'
import { getAllCurrencyApi } from '@/api/common/currency'
import { notifyError } from '@/utils/toast'
import BookingFormDepositDialog from './BookingFormDepositDialog.vue'
// import CurrencyInput from '@/components/ui/currencyInput'
import {
  getListSubTransactionApi,
  getReceiveBankAccountApi,
  codeBaseApi,
  addDepositApi
} from '@/api/booking_service/bookingGroup'
// import { ValidationObserver } from 'vee-validate'
export default {
  components: {
    // SingleCalendar,
    // SelectWithSearchTable,
    // CalendarSelect,
    // ValidationObserver,
    BookingFormDepositDialog
    // CurrencyInput
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedGroupData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      depositTypeList: [
        {
          name: 'Tiền mặt',
          id: 1
        },
        {
          name: 'Chuyển khoản',
          id: 3
        },
        {
          name: 'Thẻ tín dụng',
          id: 2
        }
      ],
      dialogDepositVisible: false,
      groupMasterData: {
        no: null,
        id: null,
        name: null,
        note: null,
        status: null,
        create_date: null,
        create_user_id: null,
        external_id: null,
        booking_code: null,
        confirm_code: null,
        first_arrival_date: null,
        last_departure_date: null,
        agent_id: null,
        agent_name: null,
        user_create: null,
        status_code: null
      },
      currentTab: 1,
      depositForm: {
        // deposit_by: null,
        deposit_money: null,
        note: null,
        sub_transaction_id: null,
        date: null,
        transaction_page: null,
        invoice_num: null,
        currency_type: null,
        debt_account_id: null,
        bank_account_id: null,
        card_num: null,
        expire_date: null
      },
      depositDefaultForm: {
        // deposit_by: null,
        deposit_money: null,
        note: null,
        sub_transaction_id: null,
        date: null,
        transaction_page: null,
        invoice_num: null,
        currency_type: null,
        debt_account_id: null,
        bank_account_id: null,
        card_num: null,
        expire_date: null
      },

      //   columns and options info in select
      tranferPageColumns: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          minWidth: 50,
          maxWidth: 100
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          tooltipField: 'desc',
          minWidth: 100
        }
      ],
      typeColumns: [
        {
          headerName: 'Mã giao dịch',
          headerTooltip: 'Mã giao dịch',
          field: 'code',
          tooltipField: 'code',
          minWidth: 70,
          maxWidth: 120
        },
        {
          headerName: 'Mô tả',
          field: 'description',
          tooltipField: 'description',
          minWidth: 100
        }
      ],
      accountColumns: [
        {
          headerName: 'Mã tài khoản',
          headerTooltip: 'Mã tài khoản',
          field: 'code',
          tooltipField: 'code',
          minWidth: 70,
          maxWidth: 100
        },
        {
          headerName: 'Số tài khoản',
          headerTooltip: 'Số tài khoản',
          field: 'acc_num',
          tooltipField: 'acc_num',
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Tên ngân hàng',
          headerTooltip: 'Tên ngân hàng',
          field: 'name',
          tooltipField: 'name',
          minWidth: 100
        }
      ],
      accountOptions: [],
      subTransactionList: [],
      currencyOptions: [],
      tranferPageList: []
    }
  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.dialogDepositVisible = this.dialogVisible
      }
    },
    selectedGroupData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.groupMasterData = this.selectedGroupData
        }
      }
    }
  },
  async mounted() {
    this.fnGetTranferPage()
    this.fnGetListSubTransaction()
    this.fnGetReceiveBankAccount()
    this.fnGetCurrencyList()
  },
  methods: {
    onTabClick(params) {
      // this.depositForm.deposit_by = params.
      this.currentTab = params.$attrs.value
    },

    async fnGetListSubTransaction() {
      const data = await getListSubTransactionApi()
      this.subTransactionList = data.data ?? []
    },

    async fnGetReceiveBankAccount() {
      const data = await getReceiveBankAccountApi({
        pageSize: 100,
        pageNum: 1,
        active: true
        // showNotActive: false
      })
      this.accountOptions = data.data ?? []
    },

    async fnGetCurrencyList() {
      const data = await getAllCurrencyApi()
      this.currencyOptions = data.data ?? []
    },

    async fnGetTranferPage() {
      const data = await codeBaseApi({ pCode: 'TRANPAGE' })
      this.tranferPageList = data.data ?? []
    },

    // select row
    onSelectRowTranferPage(val) {
      this.depositForm.transaction_page = val.id
    },
    onSelectRowType(val) {
      this.depositForm.sub_transaction_id = val.id
    },

    onSelectRowAccount(val) {
      this.depositForm.bank_account_id = val.id
    },

    onCloseDepositDialog() {
      // this.depositForm = Object.assign({}, this.depositDefaultForm)
      this.$emit('closeDialog')
    },

    async handleDeposit() {
      // call api
      // alert('Đặt cọc cho phòng: ' + this.selectedGroupData.booking_code)
      if (
        (await this.$vxForm.isValid(
          this.$refs['depositFormValidator' + this.currentTab][0]
        )) === false
      ) {
        return
      }
      var params = {
        ...this.depositForm,
        deposit_money:
          this.currencyOptions.filter(
            item => item.id === this.depositForm.currency_type
          )[0].exchange_rate * this.depositForm.deposit_money,
        deposit_by: this.currentTab,
        booking_group_id: this.selectedGroupData.id
      }
      // alert('add mission!!')
      await addDepositApi(params)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Đặt cọc thành công'
          })
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + error.response.data.message)
          })
        })
        .finally(() => {
          this.depositForm = Object.assign({}, this.depositDefaultForm)
          this.$emit('closeDialog')
        })
    },

    async onCreateDeposit() {
      const error = this.$refs.BookingFormDepositDialog.validateFormData()
      if (error) {
        notifyError(error, true)
        return
      }
      // TODO: Extract submit logic from this form
      const payload = await this.$refs.BookingFormDepositDialog.dehydrateForm()
      payload.booking_group_id = this.selectedGroupData?.id
      await createBookingDeposit(payload)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Đã đặt cọc thành công'
          })
        })
        .catch(err => {
          const message = err?.response?.data?.message
          this.$message({
            type: 'error',
            message: message ?? 'Đã có lỗi xảy ra'
          })
        })

      // await getBookingBalance(this.selectedGroupData?.id)
      //   .then(res => {
      //     this.depositedMoney = res?.data ?? 0
      //   })
      //   .catch(err => {
      //     const message = err?.response?.data?.message
      //     this.$message({
      //       type: 'error',
      //       message: message ?? 'Đã có lỗi xảy ra'
      //     })
      //   })

      this.$refs.BookingFormDepositDialog.hydrateForm()
      this.$emit('closeDialog')
    }
  }
}
</script>
<style scoped>
.w-33 {
  width: 33%;
}
.w-50 {
  width: 50%;
}
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}
.deposit-date::v-deep .vc-popover-content-wrapper.is-interactive {
  position: fixed !important;
  inset: unset !important;
  transform: translate(0px, 0px) !important;
}
</style>
